import { createContext, useContext, useState } from "react";

const StateProviderContext = createContext();

export const useStateProvider = () => {
  return useContext(StateProviderContext);
};

export default function StateManagmentProvider({ children }) {
  const [showTabs, setShowTabs] = useState("dashboard"); //SIDEBAR TAB
  const [showData, setShowData] = useState(false); //OPEN SIDEBAR
  const [activeTab, setActiveTab] = useState("newContacts");
  const [deleteModal, setDeleteModal] = useState(false); //DELETE MODEL
  const [deletModalHeading, setdeletModalHeading] = useState(""); //DELETE MODEL HEADING
  const [markModal, setmarkModal] = useState(false); //Mark Complete MODEL
  const [markCompleteModalHeading, setmarkCompleteModalHeading] = useState(""); //Mark Complete MODEL HEADING
  const [teamActiveTab, setTeamActiveTab] = useState("myteammates");
  const [attachFileModal, setAttachFileModal] = useState(false); //ATTACH FILE MODAL
  const [profileItemPage, setProfileItemPage] = useState(false); //TODAY WORKFLOW ITEM PROFILE PAGE
  const [createFollowUpPopUp, setCreateFollowUpPopUp] = useState(false); //TODAY WORKFLOW ITEM PROFILE PAGE
  const [profileCalendar, setProfileCalendar] = useState(false);
  const [profileAttachFileModal, setprofileAttachFileModal] = useState(false); //ATTACH FILE MODAL
  const [todaysWorkflowProfile, setTodaysWorkflowProfile] = useState(""); //Todays Workflow
  const [todaysWorkflowIndex, setTodaysWorkflowIndex] = useState(""); //Todays Workflow card index
  const [todayWorkflowUpdate, setTodayWorkflowUpdate] = useState(""); //Todays Workflow Updated
  const [blogSliderData, setBlogSliderData] = useState(""); //Blogs Cards Slider Data

  const [logChatNotesModal, setLogChatNotesModal] = useState(false); //Log Chat Notes Modal
  const [logChatModal, setLogChatModal] = useState(false); //Set Daily Plan Modal
  const [quickActionModal, setQuickActionModal] = useState(false);
  // COUNTER VALUES
  const [counterValue, setCounterValue] = useState(0);
  const [saveValueCounter, setSaveValueCounter] = useState();
  // ====================
  const [cardData, setCardData] = useState("");
  const value = {
    showTabs,
    setShowTabs,
    showData,
    setShowData,
    activeTab,
    setActiveTab,
    deleteModal,
    setDeleteModal,
    deletModalHeading,
    setdeletModalHeading,
    markModal,
    setmarkModal,
    markCompleteModalHeading,
    setmarkCompleteModalHeading,
    teamActiveTab,
    setTeamActiveTab,
    attachFileModal,
    setAttachFileModal,
    profileItemPage,
    setProfileItemPage,
    createFollowUpPopUp,
    setCreateFollowUpPopUp,
    profileCalendar,
    setProfileCalendar,
    profileAttachFileModal,
    setprofileAttachFileModal,

    // COUNTER VALUES
    setCounterValue,
    counterValue,
    saveValueCounter,
    setSaveValueCounter,
    // Dashboards Todays Workflow
    todaysWorkflowIndex,
    setTodaysWorkflowIndex,
    todaysWorkflowProfile,
    setTodaysWorkflowProfile,
    setTodayWorkflowUpdate,
    todayWorkflowUpdate,
    // BLOG CARDS SLIDER DATA
    blogSliderData,
    setBlogSliderData,
    setCardData,
    cardData,

    //====== Log Chat Notes Modal Value
    logChatNotesModal,
    setLogChatNotesModal,

    //Set Daily Plan Value
    logChatModal,
    setLogChatModal,
    //===
    quickActionModal,
    setQuickActionModal,
  };
  return (
    <StateProviderContext.Provider value={value}>
      {children}
    </StateProviderContext.Provider>
  );
}
